import { Page } from "@shopify/polaris";
import { useDispatch } from "react-redux";
import { AppDispatch } from "configureStore";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { setModalxComponent } from "components/modalx/modalx.slice";
import DepartmentsList from "containers/departments/departments-container";
import { AuditLogPopover } from "components/audit-log/audit-log-popover";
import PersonalasTabs from "features/positions/PersonalasTabs";
import { useAppSelector } from "hooks";
import { canManageDepartments } from "features/personnel/personnel-helpers";
import { isMaster } from "utils/onboardingPermissions";

/**
 * Departments page: the list of departments with create/edit, shown as the
 * «Skyriai» tab of Personalas. The WS specialist reads it only. (Permission-
 * based menu visibility is handled globally by DashboardLayout, not here.)
 */
function DepartmentsPage() {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const { companyId } = useParams();
  const role = useAppSelector((state) => state.authReducer.role);
  const canManage = canManageDepartments(role);

  const handleCreateDepartment = () => {
    dispatch(setModalxComponent("DepartmentForm"));
  };

  if (!companyId) {
    return null;
  }

  return (
    <>
      <div className="px-6 pt-4">
        <PersonalasTabs companyId={companyId} />
      </div>
      <Page
        fullWidth
        title={t("departments")}
        // The company-wide history (no subjectId) is Master-only on the backend.
        titleMetadata={isMaster(role) ? <AuditLogPopover subjectType="Department" /> : undefined}
        primaryAction={canManage ? { content: t("create"), onAction: handleCreateDepartment } : undefined}
      >
        <DepartmentsList canManage={canManage} />
      </Page>
    </>
  );
}

export default DepartmentsPage;
